import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { ForgotPassword as ForgotPasswordThunk, ResetPassword as ResetPasswordThunk } from '../../store/MSIdentity/thunks';
import Logo from '../../globals/images/Layout/logo3.svg';
import styles from './ForgotPassword.module.scss';

const ForgotPassword: React.FC = () => {
  const dispatch = useDispatch<any>();
  const history = useHistory();

  const [step, setStep] = useState<'email' | 'reset'>('email');
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const passwordsMismatch = confirmPassword !== '' && newPassword !== confirmPassword;

  const handleSendCode = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    const result = await dispatch(ForgotPasswordThunk({ email }));
    setIsLoading(false);
    if (result) {
      setStep('reset');
    }
  };

  const handleReset = async (e: React.FormEvent) => {
    e.preventDefault();
    if (passwordsMismatch) return;
    setIsLoading(true);
    const result = await dispatch(ResetPasswordThunk({ email, code, newPassword }));
    setIsLoading(false);
    if (result) {
      history.push('/login');
    }
  };

  return (
    <div className={styles.wrap}>
      <div className={styles.card}>
        <div className={styles.logo}>
          <div className={styles.logoIcon}>
            <img src={Logo} alt="Glow Skin" />
          </div>
          <h1 className={styles.title}>
            {step === 'email' ? 'Recuperar contraseña' : 'Nueva contraseña'}
          </h1>
          <p className={styles.subtitle}>
            {step === 'email'
              ? 'Ingresa tu correo y te enviaremos un código de verificación.'
              : `Ingresa el código que enviamos a ${email} junto con tu nueva contraseña.`}
          </p>
        </div>

        {step === 'email' ? (
          <form className={styles.form} onSubmit={handleSendCode}>
            <label className={styles.label}>Correo electrónico</label>
            <input
              className={styles.input}
              type="email"
              placeholder="correo@ejemplo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />

            <button className={styles.btn} type="submit" disabled={isLoading}>
              {isLoading ? <span className={styles.spinner} /> : 'Enviar código'}
            </button>
          </form>
        ) : (
          <form className={styles.form} onSubmit={handleReset}>
            <label className={styles.label}>Código de verificación</label>
            <input
              className={styles.input}
              type="text"
              inputMode="numeric"
              placeholder="123456"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              maxLength={6}
            />

            <label className={styles.label}>Nueva contraseña</label>
            <div className={styles.passwordWrapper}>
              <input
                className={styles.input}
                type={showPassword ? 'text' : 'password'}
                placeholder="••••••••"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength={6}
                autoComplete="new-password"
              />
              <button
                type="button"
                className={styles.eyeBtn}
                onClick={() => setShowPassword(!showPassword)}
                tabIndex={-1}
              >
                {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
              </button>
            </div>

            <label className={styles.label} style={{ marginTop: '1.25rem' }}>Confirmar contraseña</label>
            <input
              className={styles.input}
              type={showPassword ? 'text' : 'password'}
              placeholder="••••••••"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              autoComplete="new-password"
            />
            {passwordsMismatch && (
              <p className={styles.error}>Las contraseñas no coinciden</p>
            )}

            <button className={styles.btn} type="submit" disabled={isLoading || passwordsMismatch}>
              {isLoading ? <span className={styles.spinner} /> : 'Restablecer contraseña'}
            </button>
          </form>
        )}

        <button className={styles.backBtn} type="button" onClick={() => history.push('/login')}>
          Volver a iniciar sesión
        </button>

        <p className={styles.footer}>© {new Date().getFullYear()} Glow Skin · Todos los derechos reservados</p>
      </div>
    </div>
  );
};

export default ForgotPassword;
